import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import AvatarGroup from "@mui/material/AvatarGroup";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import {
  Alert,
  Button,
  Chip,
  CircularProgress,
  Collapse,
  Dialog,
  DialogActions,
  DialogTitle,
  Pagination,
  Stack,
  Switch,
  TablePagination,
  TableSortLabel,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import "./PageGroupCustomTable.css";
import AdditionalPageGroupContent from "./AdditionalPageGroupContent";
import DuplicatePageGroupModal from "../PageGroupModal/DuplicatePageGroupModal";
import EditNewRequestModal from "../PageGroupModal/EditNewRequestModal";
import IconButton from "@mui/material/IconButton";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { Box } from "@mui/system";
import { CheckPermissions } from "../../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { useSelector } from "react-redux";
import {
  selectUserData,
  selectUserToken,
  setDisplayErrorSnackBar,
} from "../../../../../features/userSlice";
import { PageGroupEndPointLogic } from "../../../../../logic/AssetManagement/PageGroups/pageGroupEndPointLogic";
import { useSearchParams } from "react-router-dom";
import {
  setPage,
  setSelectedStatus,
} from "../../../../../features/pageGroupSlice";
import store from "../../../../../store";
// import SuccessSnackbar from "../../../../CommonSuccessSnackbar/SuccessSnackbar";
import { Link as LinkRedirection } from "react-router-dom";
import { DeactivateConfirmationForPageGroups } from "./DeactivateConfirmationForPageGroups";
interface Props {
  tableHeadings: { [key: string]: string };
  pageGroups: any[];
  selectedTheme: any;
  selectedPopup: any;
  selectedPageGroup: any;
  selectedSiteUid: any;
  setTableRefresh: any;
  duplicatePageGroupData: any;
  setDuplicatePageGroupData: any;
  setSnackbarOpen: any;
  pages: any;
  fetchPageGroups: any;
}

function PageGroupCustomTable({
  tableHeadings,
  selectedSiteUid,
  duplicatePageGroupData,
  setDuplicatePageGroupData,
  setTableRefresh,
  setSnackbarOpen,
  pages,
  // fetchPageGroups,
}: Props) {
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [additionalContent, setAdditionalContent] = React.useState<any[]>([]);
  const [sortedData, setSortedData] = useState<any[]>([]);
  const [openRow, setOpenRow] = React.useState<number | null>(null);
  const headCells = Object.entries(tableHeadings);
  const [singlePageGroupData, setSinglePageGroupData] = useState<any>();
  const [singlePageGroup, setSinglePageGroup] = useState<any>(null);
  const [singleTableData, setSingleTableData] = useState<any>([]); // Data of the row that is clicked for duplicate modal
  const response = useSelector(selectUserData);
  const [loading, setLoading] = useState(false);
  const hasEditPageGroupPermission = CheckPermissions(
    response?.data?.products?.assets,
    "websites",
    "edit_page_groups",
  );
  const hasDuplicatePageGroupPermission = CheckPermissions(
    response?.data?.products?.assets,
    "websites",
    "duplicate_page_groups",
  );
  const {
    pageGroupData,
    page,
    selectedPageGroup,
    selectedSharedUid,
    selectedStatus,
    selectedFilterTheme,
    selectedFilterPopups,
  } = useSelector((state: any) => state.pageGroup);

  const [searchParams, setSearchParams] = useSearchParams();

  const selectedSite = searchParams.get("selectedSite");
  const handleChangePage = (_: unknown, newPage: number) => {
    store.dispatch(setPage(newPage));

    setSearchParams((prevParams) => {
      const updatedParams = new URLSearchParams(prevParams);
      updatedParams.set("page", newPage.toString());
      return updatedParams;
    });
  };

  const token: any = useSelector(selectUserToken);
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const newRowsPerPage = +event.target.value;

    setRowsPerPage(newRowsPerPage);

    // Dispatch to Redux store to reset page
    store.dispatch(setPage(0));

    // Update the URL params to reflect page 0
    setSearchParams((prevParams) => {
      const updatedParams = new URLSearchParams(prevParams);
      updatedParams.set("page", "0");
      return updatedParams;
    });
  };

  const handleRowClick = (index: number, row: any) => {
    setOpenRow((prev) => (prev === index ? null : index));
    setAdditionalContent(row);
  };

  const [openDuplicateModal, setopenDuplicateModal] = useState(false);

  const handleOpenDuplicateModal = (row: any) => {
    setopenDuplicateModal(true);
    setSingleTableData(row);
  };

  const handleCloseDuplicateModal = () => {
    setopenDuplicateModal(false);
  };

  const [openEditnewModal, setopenEditnewModal] = useState(false);
  const [toggleLoader, setToggleLoader] = useState(false);
  const [isDisableConfirmationOpen, setIsDisableConfirmationOpen] =
    useState(false);
  const [isDisableOpenPageCount, setIsDisableOpenPageCount] = useState(false);
  const [rowToDisable, setRowToDisable] = useState<any>(null);
  const [, setTogglePageGroupData] = useState<any[]>([]);

  const handleopenEditnewModal = async (row: any) => {
    setLoading(true);
    try {
      await PageGroupEndPointLogic.getSinglePageGroup(
        token,
        selectedSharedUid,
        row.shared_uid,
        setSinglePageGroup,
      );
      setopenEditnewModal(true);
      setSinglePageGroup(row);
      setSinglePageGroupData(row);
    } catch (error) {
      console.error("Error fetching single page group data:", error);
    } finally {
      setLoading(false); // Reset loading state after the API call
    }
  };

  const handlecloseEditnewModal = () => {
    setopenEditnewModal(false);
  };

  const [sort, setSort] = useState<{
    keytoSort: string | undefined;
    direction: "asc" | "desc" | undefined;
  }>({
    keytoSort: "modified",
    direction: "desc",
  });

  const tableheaders = [
    { id: 0, KEY: "group_name", label: "Name", sortable: true },
    { id: 1, KEY: "pages_count", label: "Pages in Group", sortable: true },
    { id: 2, KEY: "active", label: "Status", sortable: true },
    { id: 2, KEY: "themes", label: "Theme", sortable: true },
    { id: 3, KEY: "popups", label: "Popups", sortable: true },
    { id: 4, KEY: "ab_test", label: "A/B Test", sortable: true },
    { id: 4, KEY: "quick_actions", label: "Quick Actions", sortable: false },
    { id: 4, KEY: "more_info", label: "More info", sortable: false },
  ];

  const handleHeaderClick = (header: any) => {
    if (!header.sortable) return; // Ignore click if column is not sortable

    setSort({
      keytoSort: header.KEY,
      // Toggle sort direction if the same column is clicked, otherwise default to ascending
      direction:
        header.KEY === sort.keytoSort && sort.direction === "asc"
          ? "desc"
          : "asc",
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getSortedData = React.useCallback(
    (arrayToSort: any[]) => {
      if (!sort.keytoSort || !sort.direction) {
        return arrayToSort;
      }

      return arrayToSort.slice().sort((a, b) => {
        const keytoSort = sort.keytoSort;

        if (keytoSort === undefined) {
          return 0;
        }

        let aValue, bValue;

        if (keytoSort === "themes" || keytoSort === "popups") {
          // Aggregate themes into a single string for sorting
          aValue =
            a.themes?.flatMap((theme: any) => theme.name).join(", ") || "";
          bValue =
            b.themes?.flatMap((theme: any) => theme.name).join(", ") || "";
        } else {
          aValue = a[keytoSort];
          bValue = b[keytoSort];
        }

        if (keytoSort === "ab_test") {
          aValue = a.ab_test?.theme ? 1 : 0;
          bValue = b.ab_test?.theme ? 1 : 0;
        }

        if (aValue === undefined) return 1;
        if (bValue === undefined) return -1;

        if (aValue === "") return 1;
        if (bValue === "") return -1;

        if (typeof aValue === "string" && typeof bValue === "string") {
          return sort.direction === "asc"
            ? aValue.localeCompare(bValue)
            : bValue.localeCompare(aValue);
        } else if (typeof aValue === "number" && typeof bValue === "number") {
          return sort.direction === "asc" ? aValue - bValue : bValue - aValue;
        } else {
          return sort.direction === "asc"
            ? String(aValue).localeCompare(String(bValue))
            : String(bValue).localeCompare(String(aValue));
        }
      });
    },
    [sort],
  );

  const filteredData =
    sortedData &&
    sortedData?.filter((group: any) => {
      const selectedThemeName =
        selectedFilterTheme && selectedFilterTheme.length !== 0
          ? group?.themes?.some((theme: any) =>
              selectedFilterTheme.includes(theme.name),
            )
          : true; // If no Asset is selected, treat it as a match

      const isActive = selectedStatus.includes(group.active.toString());

      const selectedPopupName =
        selectedFilterPopups && selectedFilterPopups.length !== 0
          ? group?.popups?.some((popup: any) =>
              selectedFilterPopups.includes(popup.name),
            )
          : true; // If no Asset is selected, treat it as a match

      const sellectedPageGroup =
        selectedPageGroup && selectedPageGroup.length !== 0
          ? selectedPageGroup.includes(group.group_name)
          : true;

      return (
        selectedThemeName &&
        selectedPopupName &&
        sellectedPageGroup &&
        (selectedStatus.length === 0 || isActive)
      );
    });

  useEffect(() => {
    const sortedRows = getSortedData(pageGroupData || []);
    setSortedData(sortedRows);
    setOpenRow(null);
  }, [
    pageGroupData,
    getSortedData,
    selectedFilterPopups,
    selectedFilterTheme,
    selectedPageGroup,
  ]);

  useEffect(() => {
    const pageFromUrl = Number(searchParams.get("page")); // Convert to number
    store.dispatch(setPage(isNaN(pageFromUrl) ? 0 : pageFromUrl)); // Ensure it defaults correctly
  }, [searchParams]);

  useEffect(() => {
    if (page !== 0) {
      store.dispatch(setPage(0));
    }
    // eslint-disable-next-line
  }, [selectedFilterTheme, selectedFilterPopups, selectedPageGroup && page]);

  const hasWebsitePageGroupsTogglePermissions = CheckPermissions(
    response?.data?.products?.assets,
    "websites",
    "edit_page_groups",
  );

  const handleTogglePageGroupStatus = async (row: any) => {
    const data = { active: !row.active };

    if (row.active === false) {
      // When activating a deactivated group — open Edit modal immediately
      try {
        await handleopenEditnewModal(row);
        await PageGroupEndPointLogic.toggleStatusPageGroup(
          token,
          data,
          selectedSharedUid,
          row?.shared_uid,
          setTogglePageGroupData,
        );
      } catch (error) {
        console.error("Error saving page group:", error);
      }
    } else {
      // When deactivating, and group has pages, prepare filtered pages for reassignment flow
      const filtered =
        pages.filter((p: any) => p?.page_group_name === row?.group_name) || [];
      setRowToDisable({ row, data, filteredPages: filtered }); // store the row + toggle payload + filtered pages
      if (row.pages_count <= 0) {
        setIsDisableConfirmationOpen(true); // open the dialog
      } else {
        setIsDisableOpenPageCount(true);
      }
    }
  };

  const handleConfirmDisable = async () => {
    if (!rowToDisable) return;
    const { row, data } = rowToDisable;

    try {
      setToggleLoader(true);
      await PageGroupEndPointLogic.toggleStatusPageGroup(
        token,
        data,
        selectedSharedUid,
        row?.shared_uid,
        setTogglePageGroupData,
      );
      await PageGroupEndPointLogic.getAllPageGroups(
        token,
        selectedSharedUid,
        setSortedData,
      );
      // await fetchPageGroups();
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Page group updated successfully",
          type: "success",
        }),
      );
    } catch (error: any) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Updating Page Groups",
          type: "error",
        }),
      );
    } finally {
      setToggleLoader(false);
      setIsDisableConfirmationOpen(false);
      setIsDisableOpenPageCount(false);
      setRowToDisable(null);
    }
  };

  const closeDisableConfirmation = () => {
    setIsDisableConfirmationOpen(false);
    setIsDisableOpenPageCount(false);
  };

  const hasAppliedDefaultStatus = useRef(false); // Ref to track if default status has been applied

  // Apply default status if no status is selected
  useEffect(() => {
    if (
      !hasAppliedDefaultStatus.current &&
      (!selectedStatus || selectedStatus.length === 0)
    ) {
      store.dispatch(setSelectedStatus(["true"]));
      hasAppliedDefaultStatus.current = true;
    }
  }, [selectedStatus]);

  return (
    <>
      <TableContainer
        className="quaterlygoalswrap"
        component={Paper}
        sx={{ maxHeight: 800, marginTop: "16px" }}
      >
        <Table aria-label="collapsible table" size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {tableheaders.map((header, index) => (
                <TableCell key={index} align="left">
                  <TableSortLabel
                    active={sort.keytoSort === header.KEY}
                    direction={
                      sort.keytoSort === header.KEY ? sort.direction : "asc"
                    }
                    onClick={() => handleHeaderClick(header)}
                    disabled={!header.sortable}
                  >
                    {header.label}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.length > 0 ? (
              filteredData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row: any, index: any) => (
                  <React.Fragment key={row.cron_id}>
                    <TableRow
                      sx={{
                        "& > *": {
                          borderBottom:
                            "1px solid rgba(224, 224, 224, 1) !important",
                        },
                      }}
                    >
                      {headCells.map(([key], idx) => (
                        <TableCell key={idx} align="left">
                          {key === "more_info" ? (
                            <TableCell
                              align="left"
                              sx={{ border: "none" }}
                              data-tracker="36"
                            >
                              <IconButton
                                data-tracker="36"
                                aria-label="expand row"
                                size="small"
                                color="secondary"
                                onClick={() => handleRowClick(index, row)}
                              >
                                {openRow === index ? (
                                  <KeyboardArrowUpIcon data-tracker="36" />
                                ) : (
                                  <KeyboardArrowDownIcon data-tracker="36" />
                                )}
                              </IconButton>
                            </TableCell>
                          ) : key === "active" ? (
                            row[key] === true ? (
                              <Box display="flex" alignItems="center">
                                {toggleLoader === row?.shared_uid ? (
                                  <CircularProgress
                                    size={24}
                                    color="secondary"
                                  />
                                ) : (
                                  <>
                                    <Alert
                                      iconMapping={{
                                        success: (
                                          <CheckCircleOutlineOutlinedIcon
                                            fontSize="inherit"
                                            style={{ color: "#1E4620" }}
                                          />
                                        ),
                                      }}
                                      sx={{
                                        height: "30px",
                                        display: "flex",
                                        alignItems: "center",
                                        width: "100px",
                                        padding: "6px",
                                        backgroundColor: "#EDF7ED",
                                        ".MuiAlert-icon": {
                                          marginRight: "5px",
                                        },
                                      }}
                                      variant="outlined"
                                      severity="success"
                                    >
                                      Active
                                    </Alert>
                                    {hasWebsitePageGroupsTogglePermissions ? (
                                      <Switch
                                        checked={row[key]}
                                        data-tracker="523"
                                        onChange={() =>
                                          handleTogglePageGroupStatus(row)
                                        }
                                        inputProps={{
                                          "aria-label": "Toggle active status",
                                        }}
                                        sx={{
                                          "& .MuiSwitch-switchBase.Mui-checked":
                                            {
                                              color: "#2E7D32",
                                            },
                                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                            {
                                              backgroundColor: "#2E7D32",
                                            },
                                        }}
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </>
                                )}
                              </Box>
                            ) : (
                              <Box display="flex" alignItems="center">
                                <Alert
                                  iconMapping={{
                                    error: (
                                      <CancelOutlinedIcon
                                        fontSize="inherit"
                                        style={{ color: "#5F2120" }}
                                      />
                                    ),
                                  }}
                                  sx={{
                                    height: "30px",
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100px",
                                    padding: "6px",
                                    backgroundColor: "#FDEDED",
                                    ".MuiAlert-icon": {
                                      marginRight: "5px",
                                    },
                                  }}
                                  variant="outlined"
                                  severity="error"
                                >
                                  Inactive
                                </Alert>
                                <>
                                  {hasWebsitePageGroupsTogglePermissions ? (
                                    <Switch
                                      checked={row[key]}
                                      data-tracker="523"
                                      onChange={() =>
                                        handleTogglePageGroupStatus(row)
                                      }
                                      inputProps={{
                                        "aria-label": "Toggle active status",
                                      }}
                                      sx={{
                                        "& .MuiSwitch-switchBase.Mui-checked": {
                                          color: "#2E7D32",
                                        },
                                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                          {
                                            backgroundColor: "#2E7D32",
                                          },
                                      }}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </>
                              </Box>
                            )
                          ) : key === "themes" ? (
                            <div className="chip-data">
                              {Object.values(row.themes)
                                .filter((theme: any) => theme?.name)
                                .map((theme: any, idx: number) => (
                                  <LinkRedirection
                                    data-tracker="373"
                                    key={idx}
                                    to={`/operations/theme?selectedSite=${selectedSite}&search=${encodeURIComponent(
                                      theme.name,
                                    ).replace(/%20/g, "+")}`}
                                    target="_blank"
                                    style={{
                                      textDecoration: "none",
                                      display: "inline-block",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <Box
                                      key={idx}
                                      sx={{
                                        backgroundColor: "#ffffff",
                                        color: "#000",
                                        // height: "px",
                                        px: 1.5,
                                        py: 0.5,
                                        display: "flex",
                                        alignItems: "center",
                                        borderRadius: "4px",
                                        fontSize: "0.890rem",
                                        fontWeight: 500,
                                        cursor: "default",
                                        mr: 1,
                                        my: 0.5,
                                        transition: "color 0.2s ease-in-out",
                                        boxShadow:
                                          "2px 2px 6px rgba(0,0,0,0.15), -1px -1px 1px rgba(0,0,0,0.05)",
                                        "&:hover": {
                                          cursor: "pointer",
                                          color: "#9c27b0",
                                          boxShadow:
                                            "2px 2px 6px rgba(188, 109, 202, 0.6), -1px -1px 1px rgba(188, 109, 202, 0.3)",
                                        },
                                      }}
                                    >
                                      {" "}
                                      {theme.name}
                                    </Box>
                                  </LinkRedirection>
                                ))}
                            </div>
                          ) : key === "popups" ? (
                            <div className="chip-data">
                              {(() => {
                                const popupEntries = Object.values(row.popups)
                                  .filter((popup: any) => popup?.name) // Get only themes with names
                                  .map((popup: any) => popup.name); // Extract theme names
                                const mainPopup = popupEntries[0] || ""; // First theme or default to "N/A"
                                const additionalCount = popupEntries.length - 1; // Count of additional themes
                                return (
                                  <>
                                    <Chip
                                      label={
                                        additionalCount > 0
                                          ? `${mainPopup}`
                                          : mainPopup
                                      }
                                      sx={{
                                        backgroundColor: "#7B1FA2",
                                        color: "#ffffff",
                                        height: "26px",
                                      }}
                                    />
                                    <AvatarGroup
                                      total={additionalCount}
                                      variant="circular"
                                    ></AvatarGroup>
                                  </>
                                );
                              })()}
                            </div>
                          ) : key === "ab_test" ? (
                            row?.ab_test?.theme ? (
                              "Yes"
                            ) : (
                              "No"
                            )
                          ) : key === "quick_actions" ? (
                            <>
                              <Box display="flex" gap={1}>
                                <Tooltip title="Edit" placement="top">
                                  <Box data-tracker="34">
                                    {hasEditPageGroupPermission ? (
                                      <IconButton
                                        size="small"
                                        onClick={() =>
                                          handleopenEditnewModal(row)
                                        }
                                      >
                                        <CreateOutlinedIcon
                                          fontSize="small"
                                          color="secondary"
                                        />
                                      </IconButton>
                                    ) : (
                                      <IconButton size="small" disabled>
                                        <CreateOutlinedIcon
                                          fontSize="small"
                                          color="disabled"
                                        />
                                      </IconButton>
                                    )}
                                  </Box>
                                </Tooltip>
                                <Tooltip
                                  title="Duplicate"
                                  placement="top"
                                  onClick={() => handleOpenDuplicateModal(row)}
                                >
                                  {hasDuplicatePageGroupPermission ? (
                                    <IconButton size="small" data-tracker="32">
                                      <ContentCopyOutlinedIcon
                                        fontSize="small"
                                        color="secondary"
                                      />
                                    </IconButton>
                                  ) : (
                                    <IconButton size="small" disabled>
                                      <ContentCopyOutlinedIcon
                                        fontSize="small"
                                        color="disabled"
                                      />
                                    </IconButton>
                                  )}
                                </Tooltip>
                                <Tooltip title="Delete" placement="top">
                                  <IconButton
                                    size="small"
                                    disabled
                                    color="primary"
                                  >
                                    <DeleteOutlineOutlinedIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </>
                          ) : key === "pages_count" ? (
                            <>
                              {row[key] && row.group_name ? (
                                <LinkRedirection
                                  to={`/performance/page_builder/?selectedSite=${selectedSite}&filters=group%3D${encodeURIComponent(
                                    row.group_name,
                                  ).replace(/%20/g, "+")}`}
                                  target="_blank"
                                  style={{
                                    textDecoration: "none",
                                    display: "inline-block",
                                    cursor: "pointer",
                                    color: "#9c27b0", // MUI 'secondary.main' equivalent
                                  }}
                                  onMouseOver={(e) =>
                                    (e.currentTarget.style.textDecoration =
                                      "underline")
                                  }
                                  onMouseOut={(e) =>
                                    (e.currentTarget.style.textDecoration =
                                      "none")
                                  }
                                >
                                  {row[key]}
                                </LinkRedirection>
                              ) : (
                                row[key] || 0
                              )}
                            </>
                          ) : row[key] ? (
                            row[key]
                          ) : (
                            ""
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          paddingBottom: 0,
                          paddingTop: 0,
                          border: "none",
                        }}
                        colSpan={Object.keys(tableHeadings).length + 1}
                      >
                        <Collapse
                          in={openRow === index}
                          timeout="auto"
                          unmountOnExit
                        >
                          <Box sx={{ padding: "20px 0px" }}>
                            {/* Additional content here */}
                            <AdditionalPageGroupContent
                              additionalContent={additionalContent}
                            />
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))
            ) : (
              <>
                <TableRow>
                  <TableCell colSpan={Object.keys(tableHeadings).length + 1}>
                    <Box
                      sx={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#00000099",
                      }}
                    >
                      <Typography>No Data Found</Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
        <Stack
          spacing={1}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <TablePagination
            rowsPerPageOptions={[]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              ".css-16c50h-MuiInputBase-root-MuiTablePagination-select,.MuiTablePagination-selectLabel":
                {
                  display: "none",
                },
              ".MuiTablePagination-actions": {
                display: "none",
              },
              ".MuiTablePagination-toolbar": {
                paddingLeft: "16px",
              },
            }}
          />
          <Pagination
            count={Math.ceil(filteredData.length / rowsPerPage)}
            onChange={(_, value) => handleChangePage(null, value - 1)}
            showFirstButton
            showLastButton
            className="pagination-button"
            color="secondary"
            // page={page}
            size="small"
            sx={{
              ".css-wjh20t-MuiPagination-ul": {
                justifyContent: "center",
              },
            }}
            page={page + 1}
          />
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              ".MuiTablePagination-actions": {
                display: "none",
              },
              ".css-levciy-MuiTablePagination-displayedRows": {
                display: "none",
              },
              ".MuiTablePagination-input": {
                marginRight: "15px",
              },
            }}
          />
        </Stack>
      </TableContainer>
      <DuplicatePageGroupModal
        open={openDuplicateModal}
        handleClose={handleCloseDuplicateModal}
        singleTableData={singleTableData}
        selectedSiteUid={selectedSiteUid}
        setTableRefresh={setTableRefresh}
        duplicatePageGroupData={duplicatePageGroupData}
        setDuplicatePageGroupData={setDuplicatePageGroupData}
        setSnackbarOpen={setSnackbarOpen}
      />
      <EditNewRequestModal
        open={openEditnewModal}
        handleClose={handlecloseEditnewModal}
        selectedSiteUid={selectedSiteUid}
        singlePageGroupData={singlePageGroupData}
        setTableRefresh={setTableRefresh}
        setSnackbarOpen={setSnackbarOpen}
        loadingForEditModal={loading}
        singlePageGroup={singlePageGroup}
        setSinglePageGroup={setSinglePageGroup}
      />
      <DeactivateConfirmationForPageGroups
        filteredData={filteredData}
        rowToDisable={rowToDisable}
        setRowToDisable={setRowToDisable}
        open={isDisableOpenPageCount}
        onClose={closeDisableConfirmation}
        handleConfirmDisable={handleConfirmDisable}
        toggleLoader={toggleLoader}
        setToggleLoader={setToggleLoader}
        setSortedData={setSortedData}
      />
      <Dialog
        open={isDisableConfirmationOpen}
        sx={{ p: 3 }}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          Are you sure you want to deactivate this Page Group?
        </DialogTitle>
        <DialogActions sx={{ px: 3, py: 3 }}>
          <Button
            onClick={closeDisableConfirmation}
            disabled={toggleLoader}
            color="secondary"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDisable}
            color="secondary"
            data-tracker="525"
            variant="contained"
            disabled={toggleLoader}
            endIcon={<PowerSettingsNewIcon />}
            loading={toggleLoader}
          >
            Deactivate
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default PageGroupCustomTable;
